import { render } from "./ManageAccount.vue?vue&type=template&id=ddedf0f4&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"

import "./ManageAccount.vue?vue&type=style&index=0&id=ddedf0f4&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddedf0f4"]])

export default __exports__